import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { FormStyle } from "../../style/theme";
import { accountName, repoList, searchRepoList } from "../../store";

const RepoForm = () => {
	const [name, setName] = useState("");
	const [account, setAccount] = useRecoilState(accountName);
	const [repo, setRepo] = useRecoilState(repoList);
	const [search, setSearch] = useRecoilState(searchRepoList);

	const onChange = useCallback(
		(e: any) => {
			e.preventDefault();
			setSearch(
				e.target.value === ""
					? []
					: repo.filter((data: any) => data.name.includes(name))
			);
		},
		[name, repo, setSearch]
	);

	return (
		<NameFormSection onChange={onChange}>
			<span>github.com/{account.toUpperCase()}/</span>
			<span className="point">&#123;</span>
			<input
				placeholder="Repository"
				value={name}
				onChange={(e) => setName(e.target.value)}
			/>
			<span className="point">&#125;</span>
			<span>/</span>
		</NameFormSection>
	);
};

const NameFormSection = styled.div`
	${FormStyle}
`;

export default RepoForm;
